<template>
    <b-overlay :show="isLoading" rounded="sm" >
        <b-card header="Notification Setting" class="my-1">
            <b-form @submit="onSubmit">
                <b-form-checkbox switch v-model="settingForm.isShow">
                    Show Full Screen Notification
                </b-form-checkbox>

                <b-form-checkbox switch v-model="settingForm.playBeep">
                    Play Sound
                </b-form-checkbox>


                <b-input-group class="my-3"
                              label="Ideal Time:"
                              append="Seconds"
                              size="sm"
                              label-for="input-ideal-time">
                    <b-form-select id="input-ideal-time" v-model="settingForm.idealTime" :options="timeOptions"  />
                </b-input-group>

                <div class="text-right">
                    <b-button type="submit" variant="primary" right>Update</b-button>
                </div>
            </b-form>
        </b-card>
    </b-overlay>
</template>

<script>
import { mapState } from 'vuex'

export default {
    computed: {
		...mapState({
            userInfo : "userInfo",
            setting : "setting"
		})
    },
    data() {
        return { 
            settingForm : {},
            isLoading:false,
            timeOptions : [30,60,90,120,180,240,300]
        }
    },
    mounted() {
        this.settingForm = this.$deepCopy(this.setting.notification)
    },
    methods:{
        onSubmit(event) {
            event.preventDefault()
            this.$store.commit('updateSettingNotification', this.settingForm)
        }
    }
}
</script>

<style>

</style>